import React, { Dispatch, SetStateAction } from 'react';
import Slider, { Settings } from 'react-slick';
import {ContentProxyRaceDay, ContentProxyRaceEvent, seasonTitleKeys} from '../../../../models/contentProxyModel';
import ThumbnailCardComponent from './ThumbnailCardComponent';

export interface SingleSliderProps {
    seasonData:
        | {
        races: ContentProxyRaceEvent[];
        slidesToShow?: number;
        initialSlide?: number;
    }
        | undefined;
    currentSlide: ContentProxyRaceEvent | undefined;
    handleSelect: (event: ContentProxyRaceEvent) => void;
    season: string;
    changeRaceEvent: (
        eventId: string,
        raceDay: ContentProxyRaceDay,
        isLiveRace: boolean
    ) => void;
    setShowWatchButton: Dispatch<SetStateAction<boolean>>;
    isNewSeason?: boolean;
}

const SingleSlider = ({
                          seasonData,
                          currentSlide,
                          handleSelect,
                          season,
                          changeRaceEvent,
                          setShowWatchButton,
                          isNewSeason = false,
                      }: SingleSliderProps) => {
    const slidesToShow = seasonData?.slidesToShow ?? 5;
    const initialSlide = seasonData?.initialSlide ?? 0;

    const settings: Settings = {
        dots: false,
        speed: 500,
        className: 'center',
        centerMode: true,
        infinite: true,
        slidesToShow,
        slidesToScroll: 1,
        adaptiveHeight: false,
        lazyLoad: 'progressive',
        initialSlide,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const seasonTitle = seasonTitleKeys[season] || season

    return (
        <div className={`sliderWrapper ${isNewSeason ? 'slide-in' : ''}`}>
            <h2 className="seasonTitle">{`Season ${seasonTitle}`}</h2>
            <Slider
                {...settings}
                className={`${seasonData && seasonData.races.length <= 5 ? 'sliderCentred' : ''}`}
            >
                {seasonData?.races.map((event: ContentProxyRaceEvent, i: number) => (
                    <ThumbnailCardComponent key={i} event={event} currentSlide={currentSlide} handleSelect={handleSelect} changeRaceEvent={changeRaceEvent} setShowWatchButton={setShowWatchButton} />
                ))}
            </Slider>
        </div>
    );
};

export default SingleSlider;